import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DialogComponent } from "../components/dialog/dialog.component";
import { DialogDataModel } from "../models/dialog-data.model";
import { DialogMessageComponent } from "@app/dashboard/dialog-message/dialog-message.component";
import { ConfirmationDialogComponent } from "@app/confirmation-dialog/confirmation-dialog.component";

@Injectable({
    providedIn: 'root'
})
export class DialogService {

    constructor(private dialog: MatDialog) {
    }

    showDialog(data: DialogDataModel = {}, options: MatDialogConfig = {}) {
        data = data ? data : {};
        data.buttons = data.buttons ? data.buttons : [{ key: 'okay', value: 'Okay' }];
        options.panelClass = (options['panelClass'] ? [options[`panelClass`], 'user-alert-dialog'] : ['user-alert-dialog']) as string[];
        return this.openDialog({
            data: {
                ...data
            }, disableClose: true,           // Prevents closing on outside click or ESC
  hasBackdrop: true,            // Shows backdrop to block interaction
  backdropClass: 'dialog-backdrop', // Optional: custom styling
            ...options,
        });
    }

    openDialog(config: MatDialogConfig = {}) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        Object.assign(dialogConfig, config);
        return this.dialog.open(DialogComponent, dialogConfig,);
    }

     openDialog1(config: MatDialogConfig = {}) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true; // 🔒 Prevent closing on backdrop or ESC
      dialogConfig.autoFocus = true;
      dialogConfig.panelClass = 'auto-width-dialog';
      Object.assign(dialogConfig, config);
      return this.dialog.open(DialogMessageComponent, dialogConfig); // ✅ Use your DialogMessageComponent
    }
     openDialogConfirm(config: MatDialogConfig = {}) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true; // 🔒 Prevent closing on backdrop or ESC
      dialogConfig.autoFocus = true;
      Object.assign(dialogConfig, config);
      return this.dialog.open(ConfirmationDialogComponent, dialogConfig); // ✅ Use your DialogMessageComponent
    }

}